import { createIcons, icons } from 'lucide';

function renderIcons() {
  createIcons({
    icons,
    attrs: {
      'stroke-width': 1.5,
    }
  });
}

document.addEventListener("turbo:before-morph-attribute", (event) => {
  const { target, detail } = event;

  if (target instanceof HTMLDialogElement && detail.attributeName === "open" && detail.mutationType === "remove") {
    event.preventDefault();
    target.close();
  }
});

// Initialize Lucide icons
document.addEventListener('DOMContentLoaded', renderIcons);

// Re-initialize icons after Turbo navigation
document.addEventListener('turbo:render', renderIcons);

// Re-initialize icons after Turbo frame updates
document.addEventListener('turbo:frame-load', renderIcons);
